/* seaport: image fade-in, scroll reveal, homepage grid filter */
(function () {
  'use strict';

  function markLoaded(img) { img.classList.add('is-loaded'); }

  function whenLoaded(img, fn) {
    if (img.complete) return fn();
    img.addEventListener('load', fn, { once: true });
    img.addEventListener('error', fn, { once: true });
  }

  /* hover photos: only shown once loaded, and start loading as soon as the card is approached */
  function initHovers(root) {
    var canHover = window.matchMedia && matchMedia('(hover: hover)').matches;
    root.querySelectorAll('.sp-card').forEach(function (card) {
      var img = card.querySelector('.sp-card__img--hover');
      if (!img || card.hasAttribute('data-hover-ready')) return;
      card.setAttribute('data-hover-ready', '');
      whenLoaded(img, function () { if (img.naturalWidth) markLoaded(img); });
      if (!canHover) return;
      var warm = function () { if (img.loading === 'lazy') img.loading = 'eager'; };
      card.addEventListener('pointerenter', warm, { once: true });
      card.addEventListener('focusin', warm, { once: true });
    });
  }

  function initFades(root) {
    root.querySelectorAll('.sp-fade:not(.is-loaded)').forEach(function (img) {
      whenLoaded(img, function () { markLoaded(img); });
    });
  }

  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 }) /* any ratio > 0 can be unreachable for very tall sections */
    : null;

  function initReveals(root) {
    root.querySelectorAll('.sp-reveal:not(.is-in)').forEach(function (el) {
      if (observer) observer.observe(el); else el.classList.add('is-in');
    });
  }

  function initFilters(root) {
    root.querySelectorAll('[data-sp-filter]:not([data-ready])').forEach(function (section) {
      section.setAttribute('data-ready', '');
      var pills = section.querySelectorAll('[data-filter]');
      var cards = section.querySelectorAll('.sp-card');
      var empty = section.querySelector('.sp-empty');

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var filter = pill.getAttribute('data-filter');
          var shown = [];
          pills.forEach(function (p) { p.setAttribute('aria-pressed', p === pill ? 'true' : 'false'); });
          cards.forEach(function (card) {
            var match = filter === 'all' ? !card.hasAttribute('data-extra') : card.getAttribute('data-kind') === filter;
            card.hidden = !match;
            card.classList.remove('is-entering');
            if (match) shown.push(card);
          });
          if (shown.length) {
            void section.offsetWidth; /* one reflow restarts every shown card's entry animation */
            shown.forEach(function (card) { card.classList.add('is-entering'); });
          }
          if (empty) empty.hidden = shown.length > 0;
        });
      });
    });
  }

  function init(root) {
    root = root || document;
    initFades(root);
    initHovers(root);
    initReveals(root);
    initFilters(root);
    window.spReady = true;
  }

  /* add-on buttons (watch link adjuster): add to cart, then open the drawer */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-sp-addon]');
    if (!btn || btn.disabled) return;
    var id = btn.getAttribute('data-sp-addon');
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'adding…';
    var actions = window.Shopify && window.Shopify.actions;
    var done = function () { btn.textContent = 'added ✓'; };
    var fail = function () { btn.disabled = false; btn.textContent = label; };
    var soldOut = function () { btn.textContent = 'sold out'; };
    if (actions && actions.updateCart) {
      var count = function (r) { return r && r.cart ? r.cart.totalQuantity : 0; };
      var before = actions.getCart ? actions.getCart().then(count, function () { return null; }) : Promise.resolve(null);
      before.then(function (n) {
        return actions.updateCart({ lines: [{ merchandiseId: id, quantity: 1 }] }).then(function (res) {
          /* updateCart resolves even when nothing was added, and its stock warnings can be about other lines,
             so success is judged by the cart count going up */
          var errors = (res && res.userErrors) || [];
          var stock = errors.concat((res && res.warnings) || []).some(function (p) { return /STOCK/.test(p.code || ''); });
          var added = n === null ? !stock && !errors.length : count(res) > n;
          if (added) { done(); if (actions.openCart) actions.openCart(); }
          else if (stock) soldOut();
          else fail();
        });
      }).catch(fail);
    } else {
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(id), quantity: 1 }) })
        .then(function (r) { if (r.status === 422) return soldOut(); if (!r.ok) throw new Error(); window.location.href = '/cart'; })
        .catch(fail);
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* theme editor: re-run when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
